const links = {
  external: {
    linktree: "https://linktr.ee/UBIC_at_UCSD",
    instagram:
      "https://www.instagram.com/bioinformatics_at_ucsd?igsh=NTc4MTIwNjQ2YQ%3D%3D&utm_source=qr",
    discord: "https://discord.gg/Dgt4esxQzn",
    email: "ubic@ucsd.edu",
    merchForm: "https://forms.gle/Y6xQLKW3hKxm3RX4A",
    planningGuide:
      "https://docs.google.com/spreadsheets/d/1TBdmHMDncvtJjsSszSSv7tPSTV1Xi3JAgC-KZ4ncJ2A/edit?usp=sharing",
    calendar:
      "https://calendar.google.com/calendar/u/0/embed?src=40c13fb1d65cff826bcabbf9c1f887a98e8a58d77cf738f3495443b44dd4196f@group.calendar.google.com&ctz=America/Los_Angeles",
    fanfan: "http://fanfangroup.com",
    monoceros: "https://monocerosbio.com",
  },
};

export default links;
